/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contactproductname2Inputs */

const de__field_contactproductname2 = /** @type {(inputs: _Field_Contactproductname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt`)
};

/**

* @param {_Field_Contactproductname2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_contactproductname2 = /** @type {((inputs?: _Field_Contactproductname2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contactproductname2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_contactproductname2(inputs)
});
export { _field_contactproductname2 as "_field_contactProductName" }